// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__3Iexs","loading-spinner":"styles_loading-spinner__3LuWT"};